/**
 * Review & close — `docs/visit-page.md` §16 (Board 12 A passing, B opened
 * early, C after) — and adjustments after close (§16.5).
 *
 * The office's, and it locks (do-not-substitute 12): a checklist that must
 * pass (all seven, no override, D13), the final numbers by category, then
 * **Close the visit** posts the actuals into the job and locks them; after
 * that a change is an adjustment with a reason — never an edit, never a reopen.
 */
import { z } from 'zod';
import { COST_CATEGORIES } from './values.js';
// ---------------------------------------------------------------------------
// Writes
// ---------------------------------------------------------------------------
/**
 * `POST /visits/:id/close` — **Close the visit**: `{tellSalesperson,
 * draftInvoice, note}` (§5.2). In one transaction: re-checks §16.2, posts what
 * is left, sets `state = 'closed'`, recomputes the job, does the two options,
 * writes History (§16.4).
 */
export const closeVisitSchema = z.object({
    /** **Tell <salesperson>** — default on. */
    tellSalesperson: z.boolean().default(true),
    /** **Draft the <label> invoice** — default on. */
    draftInvoice: z.boolean().default(true),
    /** *A word on the visit* (optional). */
    note: z.string().trim().max(4000).default(''),
});
/**
 * `POST /visits/:id/adjustments` — **Adjust** after close (§16.5): *Category*,
 * *Amount* (signed), **Reason** (required) → a `cost_ledger` row `kind =
 * 'adjustment'` with `work_item_id`, and the job recomputed.
 */
export const adjustmentSchema = z.object({
    category: z.enum(COST_CATEGORIES),
    /** Signed — *-58.40*. */
    amount: z.string().trim().regex(/^-?\d+(\.\d{1,2})?$/, 'An amount, like -58.40.')
        .refine((value) => !/^-?0+(\.0+)?$/.test(value), 'An adjustment of nothing changes nothing.'),
    reason: z.string().trim().min(1, 'Say why.').max(2000),
});
//# sourceMappingURL=close.js.map